import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  blogData : [],
  loading: false,
  error: null,
};

const blogSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    setBlogs(state, action) {
      state.blogData = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setBlogs, setLoading, setError } = blogSlice.actions;
export default blogSlice.reducer;
